<div class="bil-modal-container">
    <div class="bil-space-center">
        <span class="bil-font-regular bil-modal-heading">Documents Required</span>
    </div>
    <div class="seperator">
    </div>
    <div class="bil-modal-content bil-modal-margin-per-2">
        <div>
            <span class="bil-font-regular bil-modal-subheading">Please keep the scanned/soft copy of below documents
                ready(PDF or PNG or JPEG or JPG or JFIF format) :</span>
        </div>
        <div>
            <div>
                <span class="bil-font-regular bil-modal-heading bil-modal-text-color">1. Business Proof</span>
            </div>
            <div>
                <div class="bil-modal-margin-per-2">
                    <span class="bil-font-regular bil-modal-subheading">a. Registration:</span>
                </div>
                <div class="bil-modal-margin-per-3">
                    <span class="bil-font-regular bil-modal-subheading">- For sole proprietorship: </span> <span
                        class="bil-font-regular bil-modal-subheading-text"> GST certificate or Shop
                        and Establishment license or Trade license certificate or Sales Tax/VAT Registration certificate or
                      Udyog Aadhaar</span>
                </div>
                <div class="bil-modal-margin-per-3">
                    <span class="bil-font-regular bil-modal-subheading">- For partnership: </span> <span
                        class="bil-font-regular bil-modal-subheading-text"> GST certificate or Partnership Deed or
                        Registrar of Firms Certificate or Certificate/registration document issued by regulatory/ Statutory Body or
                        Trade license certificate or Sales Tax/VAT Registration certificate or Udyog Aadhaar</span>
                </div>
                <div class="bil-modal-margin-per-3">
                    <span class="bil-font-regular bil-modal-subheading">- For company: </span> <span
                        class="bil-font-regular bil-modal-subheading-text"> Memorandum of Association(MoA) and Articles of
                        Association(AoA) and Certificate of Incorporation(CoI) .</span>
                </div>
            </div>
            <div class="bil-modal-margin-per-2">
              <span class="bil-font-regular bil-modal-subheading">b. Business operating address proof </span> <span
                  class="bil-font-regular bil-modal-subheading-text">(Telephone Bill-(Landline) or Post paid bill or Registered Rent
                  Agreement or Utility Bill not older than 3 months or Shop and Establishment
                  license or Property Proof)</span>
            </div>
            <div class="bil-modal-margin-per-2">
                <span class="bil-font-regular bil-modal-subheading">c. Business PAN </span>
                <span class="bil-font-regular bil-modal-subheading-text"> (In case of sole proprietor, proprietor's
                    PAN).</span>
            </div>
        </div>
        <div>
            <div>
                <span class="bil-font-regular bil-modal-heading bil-modal-text-color">2. Bank Statements</span>
            </div>
            <div class="bil-modal-margin-per-2">
                <!-- <span class="bil-font-regular bil-modal-subheading">a. Bank Statements: </span> -->
                 <span
                    class="bil-font-regular bil-modal-subheading-text">Latest 6 months bank statement(s) (Download latest
                    6
                    months
                    e-statements via net banking. Please ensure that the file is not password protected)</span>
            </div>
            <!-- <div class="bil-modal-margin-per-2">
              <span class="bil-font-regular bil-modal-subheading">b. ITR Statements: </span> <span
                  class="bil-font-regular bil-modal-subheading-text">If loan amount greater than INR 10 lakhs.</span>
            </div> -->
        </div>
        <div>
            <div>
                <span class="bil-font-regular bil-modal-heading bil-modal-text-color">3. Owner KYC</span>
            </div>
            <div class="bil-modal-margin-per-2">
                <span class="bil-font-regular bil-modal-subheading">a. All Partner's or Director's PAN. </span>
            </div>
            <div class="bil-modal-margin-per-2">
              <span class="bil-font-regular bil-modal-subheading">b. Address proof </span>
              <span class="bil-font-regular bil-modal-subheading-text">(Voter Card or Driving License or Passport or Registered Rent
                Agreement or PAN intimation letter or Utility Bill not older than 3 months or Shop and Establishment
                license or Property Proof)
              </span>
          </div>
        </div>
    </div>
    <div class="bil-space-center bil-flex-wrap bil-modal-margin-top-2">
            <button type="button" mat-raised-button color="primary"
                (click)="close()">Continue</button>
    </div>
</div>
